// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CookiesDialog_Wrapper__3fjhb"};